import { EXCLUDED_TEMPLATE_HEADERS, organizationHeaderMap } from './generic-data';

function generateHeaders(orgType: string) {
  let headerMap = organizationHeaderMap[orgType];

  return Object.keys(headerMap)
    .filter((header: string) => {
      return !EXCLUDED_TEMPLATE_HEADERS.find((ex) => ex === header);
    })
    .reduce((acc, key) => {
      return `${acc}${headerMap[key]},`;
    }, '')
    .slice(0, -1);
}

const ESEK = `"Fylles inn dersom seksjonseier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,
${generateHeaders('ESEK')}
,,"Seksjons1","Eier","eier1@mailinator.com",210975,123456789,"Storgata 2", 1387, Oslo,Norge,1,12,,,
,,"Seksjons2","Eier","eier2@mailinator.com",121254,132456789,"Bodøgata 13", 8001, Bodø,Norge,1,11,,,
"Selskap AS",259875361,"Representant","Person","representant@mailinator.com",,162345987,"Torvet 58", 0173, Oslo,,1,3,,,,,ja`;

const BRL = `"Fylles inn dersom andelseier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,
${generateHeaders('BRL')}
,,"Andels1","Eier","eier1@mailinator.com",210975,123456789,"Storgata 2", 1387, Oslo,Norge,1,12,,,
,,"Andels2","Eier","eier2@mailinator.com",121254,132456789,"Bodøgata 13", 8001, Bodø,Norge,1,11,,,
,,"Andels3","Eier","eier3@mailinator.com",050786,162345987,"Torvet 58", 0173, Oslo,,1,3,,`;

const FLI = `"Fylles inn dersom medlemet er en organisasjon",,"Opplysinger på personlig medlem eller kontaktperson",,,,,,,,
${generateHeaders('FLI')}
,,"Medlem1","Medlemsen","medlem1@mailinator.com",210975,0897,123456789,"Storgata 2", 1387, Oslo,Norge,1,2,"Ordinært medlem",,,
,,"Medlem2","Medlemsen","medlem2@mailinator.com",121254,5421,132456789,"Bodøgata 13", 8001, Bodø,Norge,1,3,"Ordinært medlem",,,
"Selskap AS",259875361,"Representant1","Person","representant@mailinator.com",,,162345987,"Torvet 58", 0173, Oslo,Norge,2,"1,4","Ordinært medlem",,,
,,"Representant2","Person","representant2@mailinator.com",,,,,,,,,,,,ja`;

const AS = `"Fylles inn dersom eier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,,,,
${generateHeaders('AS')}
"Selskap AS",256123985,"Representant1","Person","representant1@mailinator.com",,,123456789,"Storgata 2", 1387, Oslo,Norge,100,"1-50, 151-200","Ordinære aksjer","0000 11 22223",,,
,,"Aksje","Eier","eier@mailinator.com",121254,32221,132456789,"Bodøgata 13",8001, Bodø,Norge,50,"51-100","Ordinære aksjer","0000 11 22223",,,
"Selskap2 AS",259875361,"Representant2","Person","representant2@mailinator.com",,,162345987,"Torvet 58",0173,Oslo,,85,"201-285","Ordinære aksjer","0000 11 22223",,,
,,"Representant3","Person","representant3@mailinator.com",,,,,,,,,,,,,,ja`;

const Contract = `"Fylles inn dersom investor er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,,,,
${generateHeaders('Contract')}
"Selskap AS",256123985,"Representant1","Person","representant1@mailinator.com",,,123456789,"Storgata 2",1387,Oslo,Norge,,"Ordinære aksjer","0000 11 22223",,,,"1000","2026-09-08","Eksempel tegnings rett","tegningsrett","400",,,,,,"Betingelser",,"ikke innløst"
,,,,,,,,,,,,,,,,,,1000,"2026-02-08","Eksempel opsjon","opsjon","200",,,,,,"Betingelser",,
,,"Aksje","Eier","eier@mailinator.com",121254,32221,132456789,"Bodøgata 13",8001, Bodø,Norge,50,"Ordinære aksjer","0000 11 22223",,,,"10000",	"2024-09-08","Eksempel på lån","lån","500","100000","3",20000,2.5,4000,"Betingelser","3 ganger i månen","ikke innløst"`;
const owners = {
  as: `"Fylles inn dersom eier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,,,,
  ${generateHeaders('AS')}
  "Selskap AS",256123985,"Representant1","Person","representant1@mailinator.com",,,123456789,"Storgata 2", 1387, Oslo,Norge,100,"1-50, 151-200","Ordinære aksjer","0000 11 22223",,,
  ,,"Aksje","Eier","eier@mailinator.com",121254,32221,132456789,"Bodøgata 13",8001, Bodø,Norge,50,"51-100","Ordinære aksjer","0000 11 22223",,,
  "Selskap2 AS",259875361,"Representant2","Person","representant2@mailinator.com",,,162345987,"Torvet 58",0173,Oslo,,85,"201-285","Ordinære aksjer","0000 11 22223",,,
  ,,"Representant3","Person","representant3@mailinator.com",,,,,,,,,,,,,,ja`,
  fli: `"Fylles inn dersom medlemet er en organisasjon",,"Opplysinger på personlig medlem eller kontaktperson",,,,,,,,
  ${generateHeaders('FLI')}
  ,,"Medlem1","Medlemsen","medlem1@mailinator.com",210975,0897,123456789,"Storgata 2", 1387, Oslo,Norge,1,2,"Ordinært medlem",,,
,,"Medlem2","Medlemsen","medlem2@mailinator.com",121254,5421,132456789,"Bodøgata 13", 8001, Bodø,Norge,1,3,"Ordinært medlem",,,
"Selskap AS",259875361,"Representant1","Person","representant@mailinator.com",,,162345987,"Torvet 58", 0173, Oslo,Norge,2,"1,4","Ordinært medlem",,,
,,"Representant2","Person","representant2@mailinator.com",,,,,,,,,,,`,
  brl: `"Fylles inn dersom andelseier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,
  ${generateHeaders('BRL')}
  ,,"Andels1","Eier","eier1@mailinator.com",210975,123456789,"Storgata 2", 1387, Oslo,Norge,1,12,,,
,,"Andels2","Eier","eier2@mailinator.com",121254,132456789,"Bodøgata 13", 8001, Bodø,Norge,1,11,,,
,,"Andels3","Eier","eier3@mailinator.com",050786,162345987,"Torvet 58", 0173, Oslo,,1,3,,ja`,
  esek: `"Fylles inn dersom seksjonseier er en organisasjon",,"Opplysinger på personlig eier eller kontaktperson",,,,,,,,
  ${generateHeaders('ESEK')}
  ,,"Seksjons1","Eier","eier1@mailinator.com",210975,123456789,"Storgata 2", 1387, Oslo,Norge,1,12,,,
,,"Seksjons2","Eier","eier2@mailinator.com",121254,132456789,"Bodøgata 13", 8001, Bodø,Norge,1,11,,,
"Selskap AS",259875361,"Representant","Person","representant@mailinator.com",,162345987,"Torvet 58", 0173, Oslo,,1,3,,ja`,
};
export const examples = {
  ESEK,
  BRL,
  FLI,
  NIF: FLI,
  BA: FLI,
  SA: FLI,
  STI: FLI,
  FKF: FLI,
  KF: FLI,
  IKS: FLI,
  IKSR: FLI,
  SBSTI: FLI,
  ANS: FLI,
  DA: FLI,
  SPA: FLI,
  AS,
  ASA: AS,
  Contract: Contract,
  owners,
};
